import { SalesChannelCampaignCreatePage } from "@/features/sales-channel-campaign/pages/SalesChannelCampaignCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-channel-campaign/create")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["marketplace_campaigns.create"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCampaignCreatePage,
});
